var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContact38Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haldus",
    transform: "translate(-16.000000, -702.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3-Copy",
    transform: "translate(16.000000, 702.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5638852,-1.03584031e-16 L35.4361148,1.03584031e-16 C36.3276335,-6.01853049e-17 36.6509198,0.0928256111 36.9768457,0.267132704 C37.3027716,0.441439796 37.5585602,0.697228371 37.7328673,1.0231543 C37.9071744,1.34908022 38,1.67236646 38,2.5638852 L38,35.4361148 C38,36.3276335 37.9071744,36.6509198 37.7328673,36.9768457 C37.5585602,37.3027716 37.3027716,37.5585602 36.9768457,37.7328673 C36.6509198,37.9071744 36.3276335,38 35.4361148,38 L2.5638852,38 C1.67236646,38 1.34908022,37.9071744 1.0231543,37.7328673 C0.697228371,37.5585602 0.441439796,37.3027716 0.267132704,36.9768457 C0.0928256111,36.6509198 4.01235366e-17,36.3276335 -6.90560205e-17,35.4361148 L6.90560205e-17,2.5638852 C-4.01235366e-17,1.67236646 0.0928256111,1.34908022 0.267132704,1.0231543 C0.441439796,0.697228371 0.697228371,0.441439796 1.0231543,0.267132704 C1.34908022,0.0928256111 1.67236646,6.01853049e-17 2.5638852,-1.03584031e-16 Z",
    id: "Rectangle",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(10.000000, 10.000000)",
    stroke: "#FFCD00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,9 C18,13.970563 13.970563,18 9,18 C4.02943696,18 0,13.970563 0,9 C0,4.02943696 4.02943696,0 9,0 C13.970563,0 18,4.02943696 18,9 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1768256,5.77436376 C11.2079217,4.52487519 10.2750383,3.50555557 9.09338592,3.47267429 C9.06228981,3.47267429 9.0311937,3.47267429 9.00009758,3.47267429 C7.81844523,3.43979301 6.85446568,4.42623135 6.82336957,5.67571992 C6.82336957,5.7086012 6.82336957,5.74148248 6.82336957,5.77436376 C6.82336957,6.03741398 7.07213848,7.31978383 7.07213848,7.31978383 C7.25871517,8.43774728 7.94282969,9.39130435 9.00009758,9.39130435 C10.0573655,9.39130435 10.74148,8.47062856 10.9280567,7.31978383 C10.9280567,7.31978383 11.1768256,6.03741398 11.1768256,5.77436376 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34782609,15.0652174 L2.34782609,14.7913043 C2.34782609,13.5782609 3.24782609,12.6782609 4.46086957,12.3652174 L4.46086957,12.3652174 C7.46162485,11.8219772 10.5364547,11.8323843 13.533464,12.3959245 L13.5782609,12.4043478 C14.7521739,12.7565217 15.6521739,13.5782609 15.6521739,14.8304348 L15.6521739,15.1043478",
    id: "Stroke-5"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact38Px);
export default __webpack_public_path__ + "static/media/Icon_Contact-38px.dcb0e1d1ca716b09ac999982b976de50.svg";
export { ForwardRef as ReactComponent };